export default "/assets/webpack-assets/voucher-listing.3c9241c5c6fe65df71d2a539fa93745c.jpg";